module.exports = __webpack_public_path__ + "img/logo-new.27c034a1.png";